export function pauseEvent(e: any) {
    e = e || window.event;
    if(e.stopPropagation) { e.stopPropagation(); }
    if(e.preventDefault) { e.preventDefault(); }
    (e as any).cancelBubble = true;
    (e as any).returnValue = false;
    return false;
}